import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  style: {"enable-background":"new 0 0 480 480"},
  viewBox: "0 0 480 480"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M240 0C107.664 0 0 107.664 0 240s107.664 240 240 240 240-107.664 240-240S372.336 0 240 0zm0 448c-114.688 0-208-93.312-208-208S125.312 32 240 32s208 93.312 208 208-93.312 208-208 208z" }, null, -1),
    _createElementVNode("path", { d: "M352 160c-35.296 0-64 35.888-64 80s28.704 80 64 80 64-35.888 64-80-28.704-80-64-80zm0 128c-17.344 0-32-21.984-32-48s14.656-48 32-48 32 21.984 32 48-14.656 48-32 48zM144 160H96c-8.848 0-16 7.168-16 16v128c0 8.832 7.152 16 16 16h48c26.464 0 48-21.536 48-48 0-12.336-4.816-23.488-12.48-32 7.68-8.512 12.48-19.664 12.48-32 0-26.464-21.536-48-48-48zm0 128h-32v-32h32c8.832 0 16 7.184 16 16 0 8.816-7.168 16-16 16zm0-64h-32v-32h32c8.832 0 16 7.184 16 16s-7.168 16-16 16zm96-64c-8.848 0-16 7.168-16 16v128c0 8.832 7.152 16 16 16s16-7.168 16-16V176c0-8.832-7.152-16-16-16z" }, null, -1)
  ])))
}
export default { render: render }